import * as z from "zod";

/** Emails a fresh link in place of an expired one, to the address it was sent to. */
export const requestSurfaceIdentityLink = {
  name: "requestSurfaceIdentityLink" as const,
  input: z.object({ token: z.string().min(1) }),
  output: z.union([
    z.object({ ok: z.literal(true) }),
    z.object({
      ok: z.literal(false),
      reason: z.enum(["recently_sent", "unavailable", "delivery_failed"]),
    }),
  ]),
};
